<template>
  <div class="con">
    <!-- 首页头部 -->
    <headbox></headbox>
    <sectionbox></sectionbox>
    <!-- 底部 -->
    <footbox></footbox>
  </div>
</template>

<script>
import headbox from './components/home/headbox' 
import sectionbox from './components/home/sectionbox' 
import footbox from './components/footbox' 
export default {
  components: {
    headbox,
    sectionbox,
    footbox,
  },
  data () {
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="less" scoped>
.con {
  height: 100px;
}
</style>
